module.exports = __webpack_public_path__ + "static/media/expand.72cff684.svg";